module.exports = __webpack_public_path__ + "static/img/6.11574bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/6.png
// module id = SbPd
// module chunks = 0